module.exports = __webpack_public_path__ + "static/media/checklist.d44a2f46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/checklist.svg
// module id = 2325
// module chunks = 1